import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Process, General } from '../redux/action/action';
import DashboardMenuComponent from '../components/DashboardMenuComponent';
import TopProcessComponent from '../components/TopProcessComponent';
import TopComponent from '../components/TopComponent';

import InfoIcon from '../assets/images/info-icon.png';
import TooltipUbigeo from '../assets/images/tooltip-ubigeo.png';
import FormFields from '../services/FormFields';
import { Tools } from '../utils/tools';
import { Global } from '../services/Global';
import ApiService from '../services/Api';
import { APIS } from '../services/Config';

import { Distritos } from '../types/distritos';
import { Provincias } from '../types/provincias';
import TooltipDiscapacidad from '../assets/images/tooltip-discapacidad2.png';

let _fd = (localStorage.getItem('app_fd')) ? JSON.parse(Tools.decryptrData(localStorage.getItem('app_fd'))) : {};
console.log('_fd', _fd);

const mapStateToProps = (props) => { return { glo: props.general, pro: props.process } }
const mapDispatchToProps = (dispatch) => { return { general: (global) => dispatch(General(global)), process: (user) => dispatch(Process(user)) } }

class GeneralDataPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            program_selected: null,
            fields: FormFields.general_data,
            next_active: true,
            paises: [],
            distritos: [],
            provincias: [],
            edad: 0,
            loginTarget: '',
            max_lenght_document: 8,
            show_info: false,
            show_ubigeo: true,
            nivelesAcademicos: [],
            showInstitucionEducativaProcedencia: false,
            can_edit: true,
            search_result: [],
            selected_discapacidad: { opt1: false, opt2: true },
            tipos_discapacidad: [
                { "id": 919840000, "value": "Auditiva" },
                { "id": 919840001, "value": "Visual" },
                { "id": 919840002, "value": "Habla" },
                { "id": 919840003, "value": "Fisica" },
                { "id": 919840004, "value": "Intelectual" },
                { "id": 919840005, "value": "Transtorno del espectro autista" },
                { "id": 919840006, "value": "Mental" },
                { "id": 919840007, "value": "Otros" }]
        }
    }

    componentDidMount() {
        let _root = this;

        if (!_root.props.glo.isLogin) { window.location.href = '/'; }
        else {
            Tools.showPreloader();
            //Validation data default service (Sin respuesta)
            if (_root.props.pro.genero === 1) {
                _root.props.pro.genero = -1;
            }
            if (_root.props.pro.estadoCivil === 1) {
                _root.props.pro.estadoCivil = -1;
            }
            if (_root.props.pro.institucionProcedencia === 1) {
                _root.props.pro.institucionProcedencia = '';
            }
            if (_root.props.pro.idDepartamento === 26) {
                _root.props.pro.idDepartamento = -1;
            }
            if (_root.props.pro.idProvincia === 196) {
                _root.props.pro.idDepartamento = -1;
            }
            if (_root.props.pro.idProvincia === 1836 ) {
                _root.props.pro.idDistrito = -1;
            }
            _root.props.pro.tipoDocPostulante = parseInt(_root.props.pro.tipoDocPostulante);


            _root.props.glo.distritos = Distritos;
            _root.props.glo.provincias = Provincias;
            _root.setState({
                program_selected: JSON.parse(Tools.decryptrData(localStorage.getItem('app_sp'))),
                edad: _root.props.pro.edad,
                paises: _root.props.glo.paises,
                can_edit: (_root.props.pro.idSubmissionState >= 2) ? false : true,
                nivelesAcademicos: this.props.glo.gradosEstudiosAll.filter(el => ["58", "56", "53", "55", "51"].includes(el.fieldValue))
            }, () => {
                Tools.hidePreloader();
            });

            //secundaria completa, universitario y tecnico : No visible Institucion de procedencia
            _root.props.pro.nivelAcademico = (_root.props.pro.nivelAcademico === 15) ? -1 : _root.props.pro.nivelAcademico;
            _root.setState({
                showInstitucionEducativaProcedencia: !([15, 12, 11, 9, -1].includes(_root.props.pro.nivelAcademico))
            });
            _root.setState({
                show_ubigeo: (_root.props.pro.paisResidencia === 16)
            });

            if (_root.props.pro.tipoDocPostulante !== 1) {
                _root.props.pro.nroUbigeoDNI = '000000';
                //document.getElementById('nroUbigeoDNI').value = ''; TO-DO REVISAR
            }

            if (_root.props.pro.idProvincia !== "") {
                ApiService.getData(`${APIS.provincias}${_root.props.pro.idDepartamento}`)
                    .then((res) => {
                        _root.setState({
                            provincias: res.data
                        }, () => { Tools.hidePreloader(); });
                    })
                    .catch((err) => {
                        Tools.hidePreloader();
                    });

                if (_root.props.pro.idDistrito !== "") {
                    ApiService.getData(`${APIS.distritos}${_root.props.pro.idProvincia}`)
                        .then((res) => {
                            _root.setState({
                                distritos: res.data
                            }, () => { Tools.hidePreloader(); });
                        })
                        .catch((err) => {
                            Tools.hidePreloader();
                        });
                }
            }
            if (_root.props.pro.institucionProcedencia !== "") {
                ApiService.getData(`${APIS.institucionEducativa}${_root.props.pro.institucionProcedencia}`)
                    .then(resie => {
                        if (resie.data.nombre !== undefined) {
                            if (document.getElementById(`institucionProcedencia`)) { document.getElementById(`institucionProcedencia`).value = resie.data.nombre };
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    });
            }
            if (_root.props.pro.noTieneDiscapacidad !== "") {
                if (_root.props.pro.noTieneDiscapacidad === false) {
                    let option = { opt1: true, opt2: false };
                    _root.setState({
                        selected_discapacidad: option,
                    });
                } else {
                    let option = { opt1: false, opt2: true };
                    _root.setState({
                        selected_discapacidad: option,
                    });
                }
            }
        }
    }
    showInfo = (e) => {
        let _root = this;
        _root.setState({ show_info: true });
    }

    hideInfo = (e) => {
        let _root = this;
        _root.setState({ show_info: false });
    }


    onChangeSearch = e => {
        e.preventDefault();
        let _root = this;
        let _target = e.target;

        if (_target.getAttribute('data-type')) {
            if (_target.getAttribute('data-type') === 'search') {
                _root.setState({
                    search_result: []
                }, () => {
                    if (_target.value.length > 1) {
                        ApiService.getData(`${APIS.institucionesEducativasNombre}/${_target.value}`)
                            .then(res => {
                                if (res.data.length > 0) {
                                    _root.setState({
                                        search_result: res.data
                                    }, () => {
                                        if (_target.parentNode.querySelectorAll('.search-result').length > 0) {
                                            _target.parentNode.querySelectorAll('.search-result')[0].style.display = 'block';
                                        }
                                    });
                                }
                            })
                            .catch(err => {
                                console.log(err);
                            });
                    }
                    else {
                        _root.props.pro.institucionProcedencia = "";
                        _root.setState({
                            search_result: []
                        }, () => {
                            if (_target.parentNode.querySelectorAll('.search-result').length > 0) {
                                _target.parentNode.querySelectorAll('.search-result')[0].style.display = 'none';
                            }
                        });
                    }
                });
            }
        }
    }
    onChange = e => {
        // e.preventDefault();
        let _root = this;
        let _target = e.target;
        switch (_target.name) {
            case 'tipoDocPostulante':
                let tipoDocPostulanteId = parseInt(_target.value);
                _root.props.pro[_target.name] = tipoDocPostulanteId;
                _root.setState({ max_lenght_document: (tipoDocPostulanteId === 1) ? 8 : 12 })
                _root.props.pro['nroUbigeoDNI'] = '';
                break;
            case 'paisResidencia':
                let paisResidenciaId = parseInt(_target.value);
                _root.props.pro[_target.name] = paisResidenciaId;
                _root.setState({ show_ubigeo: (paisResidenciaId === 16) });
                break;
            case 'idDepartamento':
                _root.props.pro[_target.name] = parseInt(_target.value);
                _root.props.pro.idProvincia = -1;
                _root.props.pro.idDistrito = -1;
                Tools.showPreloader();
                ApiService.getData(`${APIS.provincias}${_target.value}`).then((res) => {
                    _root.setState({
                        provincias: res.data,
                        distritos: []
                    });
                    Tools.hidePreloader();
                }).catch((err) => {
                    Tools.hidePreloader();
                });
                break;
            case 'idProvincia':
                _root.props.pro[_target.name] = parseInt(_target.value);
                _root.props.pro.idDistrito = -1;
                Tools.showPreloader();
                ApiService.getData(`${APIS.distritos}${_target.value}`).then((res) => {
                    _root.setState({
                        distritos: res.data
                    });
                    Tools.hidePreloader();
                }).catch((err) => {
                    Tools.hidePreloader();
                });
                break;
            case 'fechaNacimiento':
                _root.props.pro[_target.name] = _target.value;
                _root.props.pro.edad = Global.calculateAge(_target.value);
                _root.setState({
                    edad: Global.calculateAge(_target.value)
                });
                break;
            case 'nivelAcademico':
                let nivelAcademico = parseInt(_target.value);
                _root.props.pro[_target.name] = nivelAcademico;
                _root.props.pro.institucionProcedencia = '';
                //secundaria completa, universitario y tecnico : No visible Institucion de procedencia
                _root.setState({
                    showInstitucionEducativaProcedencia: !([15, 12, 11, 9, -1].includes(nivelAcademico))
                });
                break;
            case 'discapacidad_option_1':
                _root.props.pro['noTieneDiscapacidad'] = !_target.checked
                _root.setState({
                    selected_discapacidad: { opt1: _target.checked, opt2: !_target.checked },
                });
                break
            case 'discapacidad_option_2':
                _root.props.pro['noTieneDiscapacidad'] = _target.checked
                _root.setState({
                    selected_discapacidad: { opt1: !_target.checked, opt2: _target.checked },
                });
                break
            case 'idDistrito':
            case 'genero':
            case 'estadoCivil':
                _root.props.pro[_target.name] = parseInt(_target.value);
                _root.setState({});
                break;
            default:
                _root.props.pro[_target.name] = _target.value;
                _root.setState({});
                break;
        }
    }

    onClickResultItem = (e) => {
        e.preventDefault();
        let _root = this;
        let _target = e.currentTarget;

        if (_target.getAttribute('data-id')) {
            _root.props.pro[`${_target.getAttribute('data-name')}`] = _target.getAttribute('data-id');
            document.getElementById(`${_target.getAttribute('data-name')}`).value = _target.getAttribute('data-value');
            for (let item of document.querySelectorAll('.search-result')) {
                item.style.display = 'none';
            }
        }
    }

    onKeyPressInputValidate = param => (event) => {
        Global.onKeyPressInputValidate(event, param);
    }
    onKeyPasteInputValidate = param => (event) => {
        const paste = (event.clipboardData || window.clipboardData).getData('text');
        const regex = /^[0-9]+$/;
        if (!regex.test(paste))
            event.preventDefault();
    }

    customFieldValidate(value, key, defaultMessage = null) {
        let a = document.getElementById(key);
        if (value === FormFields.general_data[key].valueValidate) {
            a.classList.add("require");
            let _html_mesg = a.parentNode.querySelector(".invalid-feedback");
            _html_mesg.textContent = defaultMessage ? defaultMessage : FormFields.general_data[key].require_msg;
            return true;
        } else {
            a.classList.remove("require");
            let _html_mesg = a.parentNode.querySelector(".invalid-feedback");
            _html_mesg.textContent = "";
        }
        return false;
    }
    onClickNext = (e) => {
        e.preventDefault();
        let _root = this;
        let _selectEntity = { ..._root.props.pro };

        console.log('_root.props.pro', _selectEntity);
        console.log('_root.props.nivelAcademico', _selectEntity.nivelAcademico);
        console.log('_root.props.genero', _selectEntity.genero);
        console.log('_root.props.genero', typeof (_selectEntity.genero));
        console.log('_root.props.cvil', _selectEntity.estadoCivil);
        console.log('_root.props.nroDocumento', _selectEntity.nroDocumento);
        console.log('_root.props.institucionProcedencia', _selectEntity.institucionProcedencia);
        console.log('_root.props.tipoDocPostulante', _selectEntity.tipoDocPostulante);
        console.log('_root.props.nacionalidad', _selectEntity.nacionalidad);

        //#Validación de campos
        let isValidateForm = [];
        isValidateForm.push(...Global.formValidationList(FormFields.general_data, _selectEntity));

        //Validacion opcional de Ubigeo
        if (_selectEntity.tipoDocPostulante === 1) {
            if (this.customFieldValidate(_selectEntity.nroUbigeoDNI, 'nroUbigeoDNI'))
                isValidateForm.push('nroUbigeoDNI');
        }
        //validacion Pais
        if (_selectEntity.paisResidencia === 16) {
            if (this.customFieldValidate(_selectEntity.idDepartamento, 'idDepartamento'))
                isValidateForm.push('idDepartamento');
            if (this.customFieldValidate(_selectEntity.idProvincia, 'idProvincia'))
                isValidateForm.push('idProvincia');
            if (this.customFieldValidate(_selectEntity.idDistrito, 'idDistrito'))
                isValidateForm.push('idDistrito');
        }
        //Validacion Institucion de procendia
        if (!([15, 12, 11, 9, -1].includes(_selectEntity.nivelAcademico))) {
            if (this.customFieldValidate(_selectEntity.institucionProcedencia, 'institucionProcedencia'))
                isValidateForm.push('institucionProcedencia');
        }

        //Validaciones con mensajes adicionales
        if (_selectEntity.edad <= 17) {
            Global.addMessageError('edad', 'La edad debe ser mayor igual a 18');
            isValidateForm.push('edad');
        } else { Global.removeMessageError('edad') }


        if (_selectEntity.tipoDocPostulante !== 1) {
            if (_selectEntity.nacionalidad === "") {
                Global.addMessageError('nacionalidad', 'Pais de Nacimiento es Requerido');
                isValidateForm.push('nacionalidad');
            } else
                Global.removeMessageError('nacionalidad');
        }

        console.log('isValidateForm', isValidateForm);
        if (isValidateForm.length > 0) return;
        
        Tools.showPreloader();
        _root.props.pro.vistasCompletadas = JSON.stringify(Global.addViewComplete(_root.props.pro.vistasCompletadas, '/datos-generales'));
        _root.props.process(_root.props.pro);
        _root.props.general(_root.props.glo);
        ApiService.postData(`${APIS.submission}`, _root.props.pro)
            .then(res => {
                Tools.hidePreloader();
                if (_root.props.pro.idSubmissionType === 3 || _root.props.pro.idSubmissionType === 4) {
                    _root.props.navigate('/informacion-laboral');
                } else {
                    _root.props.navigate('/datos-adicionales');
                }
            })
            .catch(err => {
                Tools.hidePreloader();
                console.log(err);
            });
    }

    render() {
        const {
            can_edit,
            program_selected,
            next_active,
            paises,
            distritos,
            provincias,
            edad,
            max_lenght_document,
            show_info,
            show_ubigeo,
            nivelesAcademicos,
            showInstitucionEducativaProcedencia,
            search_result,
            selected_discapacidad,
            tipos_discapacidad
        } = this.state;

        const {
            navigate
        } = this.props;

        return (
            <>
                <div className="container">
                    <div className="row app-layout-main">
                        <div id="sidebar-dashboard" className="col-md-3 left-side-dashboard">
                            {(program_selected) && <DashboardMenuComponent navigate={navigate} step={'1'} form={program_selected.form} />}
                        </div>
                        <div className="col-md-9 right-side-dashboard">
                            <TopProcessComponent porcent="0" />
                            <div className="row content-dashboard">
                                <div className="col-sm-12">
                                    <div className="row pt-3 pb-3">
                                        <div className="col-sm-12 col-md-6"><TopComponent direction="back" label="Paso Previo" path="/programa-interes" /></div>
                                        <div className="col-sm-12 col-md-6">
                                            <div className="form-group pb-2">
                                                <select className="form-control text-bold text-dark" id="idProgramaAcademico" defaultValue={this.props.pro.codOportunidad} name="idProgramaAcademico" >
                                                    {
                                                        <option key={(this.props.pro.idSubmission) + '-td'}>{this.props.pro.nomPrograma}</option>
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Tittle of General Page */}
                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-6">
                                            <h5><strong>Datos personales</strong>
                                                <img className="info_btn" src={InfoIcon} alt='' onClick={this.showInfo} />
                                            </h5>
                                        </div>
                                        <div className="col-sm-12 col-md-6">
                                            <small><strong>Comencemos. Te acompañamos paso a paso en el proceso.</strong></small>
                                        </div>
                                    </div>
                                    {/* Datos Personales*/}
                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="nombres" className="pb-2">Nombres <span className="text-danger">*</span></label>
                                                <input
                                                    type="text" className="form-control" aria-describedby="nameHelp"
                                                    id="nombres" name="nombres" placeholder="Como figuren en el DNI"
                                                    disabled={!can_edit}
                                                    value={this.props.pro.nombres}
                                                    onChange={this.onChange}
                                                    onKeyDown={this.onKeyPressInputValidate('only_letter')}
                                                    autoComplete="off" />
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="apellidoPaterno" className="pb-2">Apellido Paterno <span className="text-danger">*</span></label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="apellidoPaterno"
                                                    name="apellidoPaterno"
                                                    aria-describedby="nameHelp"
                                                    placeholder="Como figuren en el DNI"
                                                    disabled={!can_edit}
                                                    value={this.props.pro.apellidoPaterno}
                                                    onChange={this.onChange}
                                                    onKeyDown={this.onKeyPressInputValidate('only_letter')}
                                                    autoComplete="off" />
                                                <div className="invalid-feedback"></div>

                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="apellidoMaterno" className="pb-2">Apellido Materno <span className="text-danger">*</span></label>
                                                <input
                                                    type="text" className="form-control" aria-describedby="nameHelp" placeholder="Como figuren en el DNI"
                                                    id="apellidoMaterno" name="apellidoMaterno"
                                                    disabled={!can_edit}
                                                    value={this.props.pro.apellidoMaterno}
                                                    onChange={this.onChange}
                                                    onKeyDown={this.onKeyPressInputValidate('only_letter')}
                                                    autoComplete="off" />
                                                <div className="invalid-feedback"></div>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2 gri">
                                                <label htmlFor="fechaNacimiento" className="pb-2">Fecha de Nacimiento <span className="text-danger">*</span></label>
                                                <label htmlFor="edad" className="pb-2">Edad <span className="text-danger">*</span></label>
                                                <div className="input-tg-inline">
                                                    <input type="date" className="form-control"
                                                        id="fechaNacimiento" aria-describedby="nameHelp" name="fechaNacimiento"
                                                        value={this.props.pro.fechaNacimiento}
                                                        disabled={!can_edit}
                                                        onChange={this.onChange}
                                                        autoComplete="off" />
                                                    <input type="text" id="edad" name="edad" className="form-control" disabled={true} readOnly value={edad} />
                                                    <div className="invalid-feedback"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="tipoDocPostulante" className="pb-2">DNI/CE/CI <span className="text-danger">*</span></label>
                                                <select className="form-control"
                                                    id="tipoDocPostulante" name="tipoDocPostulante"
                                                    value={this.props.pro.tipoDocPostulante}
                                                    onChange={this.onChange}>
                                                    <option disabled={!can_edit} value={-1}>Selecciona una opción</option>
                                                    {
                                                        this.props.glo.tiposDocumentoIdentidad.map((item, i) => (
                                                            <option key={(item.id) + 'td'} value={item.id}>{item.descripcionCorta}</option>
                                                        ))
                                                    }
                                                </select>
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>

                                        <div className="col-sm-12 col-md-4">
                                            <div className="row">
                                                <div className={(this.props.pro.tipoDocPostulante === 1) ? 'col-sm-6' : 'col-sm-12'}>
                                                    <div className="form-group pb-2">
                                                        <label htmlFor="nroDocumento" className="pb-2">
                                                            N° de Documento <span className="text-danger">*</span></label>
                                                        <input type="text" className="form-control"
                                                            id="nroDocumento" name="nroDocumento" aria-describedby="nameHelp"
                                                            maxLength={max_lenght_document}
                                                            disabled={!can_edit}
                                                            value={this.props.pro.nroDocumento}
                                                            onChange={this.onChange}
                                                            onKeyDown={(this.props.pro.tipoDocPostulante === 1) ? this.onKeyPressInputValidate('only_number_positive') : this.onKeyPressInputValidate('only_number_and_letter')}
                                                            autoComplete="off" />
                                                        <div className="invalid-feedback"></div>
                                                    </div>
                                                </div>
                                                {(this.props.pro.tipoDocPostulante === 1) &&
                                                    <div className="col-sm-6">
                                                        <div className="form-group pb-2">
                                                            <label htmlFor="nroUbigeoDNI" className="pb-2">Número de Ubigeo <span className="text-danger">*</span> <span className='info-tooltip float-r'><img width="20px" alt='' src={InfoIcon} /> <div className="info"><img src={TooltipUbigeo} alt='' /></div></span></label>
                                                            <input type="text" className="form-control"
                                                                id="nroUbigeoDNI" name="nroUbigeoDNI"
                                                                maxLength={6}
                                                                value={this.props.pro.nroUbigeoDNI}
                                                                onChange={this.onChange}
                                                                onKeyDown={this.onKeyPressInputValidate('only_number_positive')}
                                                                onPaste={this.onKeyPasteInputValidate('only_number_positive')}
                                                                autoComplete="off" />
                                                            <div className="invalid-feedback"></div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    {/* Otros*/}
                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-6">
                                            <h5><strong>Otros</strong></h5>
                                        </div>
                                    </div>

                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="genero" className="pb-2">Sexo <span className="text-danger">*</span></label>
                                                <select className="form-control" id="genero" name="genero"
                                                    disabled={!can_edit}
                                                    value={this.props.pro.genero} onChange={this.onChange}>
                                                    <option value={-1}>Selecciona una opción</option>
                                                    {
                                                        this.props.glo.generos.map((item, i) => (
                                                            <option key={(item.id) + 'ge'} value={item.id}>{item.nombre}</option>
                                                        ))
                                                    }
                                                </select>
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="estadoCivil" className="pb-2">Estado Civil <span className="text-danger">*</span></label>
                                                <select className="form-control" id="estadoCivil" name="estadoCivil"
                                                    value={this.props.pro.estadoCivil}
                                                    disabled={!can_edit}
                                                    onChange={this.onChange} >
                                                    <option value={-1}>Selecciona una opción</option>
                                                    {
                                                        this.props.glo.estadoCivil.map((item, i) => (
                                                            <option key={(item.id) + 'ec'} value={item.id}>{item.nombre}</option>
                                                        ))
                                                    }
                                                </select>
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="celular" className="pb-2">Celular <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" id="celular" aria-describedby="nameHelp" minLength="9" name="celular"
                                                    disabled={!can_edit}
                                                    value={this.props.pro.celular}
                                                    onChange={this.onChange}
                                                    autoComplete="off" />
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="emailPersonal" className="pb-2">E-mail Personal <span className="text-danger">*</span></label>
                                                <input type="email" className="form-control bg-red" id="emailPersonal"
                                                    readOnly
                                                    value={this.props.pro.emailPersonal}
                                                    disabled={true} />
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                {(this.props.pro.tipoDocPostulante !== 1) &&
                                                    <div>
                                                        {/*  */}
                                                        {(this.props.pro.nacionalidad.length > 3) ?
                                                            <div className="form-group pb-2">
                                                                <label htmlFor="nacionalidad" className="pb-2">País de Nacimiento<span className="text-danger">*</span></label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="nacionalidad"
                                                                    aria-describedby="nameHelp"
                                                                    placeholder=""
                                                                    name="nacionalidad"
                                                                    value={this.props.pro.nacionalidad}
                                                                    onChange={this.onChange}
                                                                    autoComplete="off" />
                                                                <div className="invalid-feedback"></div>
                                                            </div>
                                                            :
                                                            <div className="form-group pb-2">
                                                                <label htmlFor="nacionalidad" className="pb-2">País de Nacimiento <span className="text-danger">*</span></label>
                                                                <select className="form-control" id="nacionalidad" name="nacionalidad" value={this.props.pro.nacionalidad} onChange={this.onChange}>
                                                                    <option disabled value="">Selecciona una opción</option>
                                                                    {
                                                                        paises.map((item, i) => (
                                                                            <option key={(item.codigoPais) + 'pan'} value={item.id}>{item.nombre}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                                <div className="invalid-feedback"></div>
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="paisResidencia" className="pb-2">País de Residencia
                                                    <span className="text-danger"> *</span>
                                                </label>
                                                <select className="form-control" id="paisResidencia" name="paisResidencia"
                                                    disabled={!can_edit}
                                                    value={this.props.pro.paisResidencia}
                                                    onChange={this.onChange}>
                                                    <option value={-1}>Selecciona una opción</option>
                                                    {
                                                        paises.map((item, i) => (
                                                            <option key={(item.codigoPais) + 'pa'} value={item.id}>{item.nombre}</option>
                                                        ))
                                                    }
                                                </select>

                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        {(show_ubigeo) &&
                                            <>
                                                <div className="col-sm-12 col-md-4">
                                                    <div className="form-group pb-2">
                                                        <label htmlFor="idDepartamento" className="pb-2">Departamento de Residencia <span className="text-danger">*</span></label>
                                                        <select className="form-control" disabled={!can_edit} id="idDepartamento" name="idDepartamento"
                                                            value={this.props.pro.idDepartamento}
                                                            onChange={this.onChange}>
                                                            <option disabled value={-1}>Selecciona una opción</option>
                                                            {
                                                                this.props.glo.departamentos.map((item, i) => (
                                                                    <option key={(item.codigoDepartamento) + 'dpto'} value={item.id} cod={item.codigoDepartamento}>{item.nombre}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <div className="invalid-feedback"></div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <div className="form-group pb-2">
                                                        <label htmlFor="idProvincia" className="pb-2">Provincia de Residencia<span className="text-danger"> *</span></label>
                                                        <select className="form-control" id="idProvincia" name="idProvincia"
                                                            disabled={!can_edit}
                                                            value={this.props.pro.idProvincia}
                                                            onChange={this.onChange}>
                                                            <option disabled value={-1}>Selecciona una opción</option>
                                                            {
                                                                provincias.map((item, i) => (
                                                                    <option key={(item.codigoProvincia) + 'prov'} value={item.id}>{item.nombre}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <div className="invalid-feedback"></div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-4">
                                                    <div className="form-group pb-2">
                                                        <label htmlFor="idDistrito" className="pb-2">Distrito de Residencia<span className="text-danger"> *</span></label>

                                                        <select className="form-control" id="idDistrito" name="idDistrito"
                                                            value={this.props.pro.idDistrito}
                                                            disabled={!can_edit}
                                                            onChange={this.onChange}>
                                                            <option disabled value={-1}>Selecciona una opción</option>
                                                            {
                                                                distritos.map((item, i) => (
                                                                    <option key={(item.codigoDistrito) + 'dist'} value={item.id}>{item.nombre}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <div className="invalid-feedback"></div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="direccion" className="pb-2">Dirección de Residencia <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" id="direccion" aria-describedby="nameHelp" name="direccion"
                                                    disabled={!can_edit} value={this.props.pro.direccion} onChange={this.onChange} autoComplete="off" />
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <div className="form-group pb-2">
                                                    <label htmlFor="nivelAcademico" className="pb-2">Nivel Académico <span className="text-danger">*</span></label>
                                                    <select className="form-control" id="nivelAcademico" name="nivelAcademico"
                                                        disabled={!can_edit}
                                                        value={this.props.pro.nivelAcademico} onChange={this.onChange}>
                                                        <option value={-1}>Selecciona una opción</option>
                                                        {
                                                            nivelesAcademicos && nivelesAcademicos.map((item, i) => (
                                                                <option key={(item.id) + 'na'} value={item.id}>{item.nombre}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <div className="invalid-feedback"></div>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            (showInstitucionEducativaProcedencia) &&
                                            <div className="col-sm-12 col-md-4">
                                                <div className="form-group pb-2">
                                                    <label htmlFor="institucionProcedencia" className="pb-2">Institución Educativa de Procedencia <span className="text-danger">*</span></label>
                                                    <div className="form-group pb-2 search-form">
                                                        <input data-level="2" type="text" className="form-control" id="institucionProcedencia" data-type="search" placeholder="Escribe el nombre de la institución" aria-describedby="nameHelp" onChange={this.onChangeSearch} autoComplete="off" />
                                                        <div className="search-result">
                                                            {
                                                                search_result && search_result.map((item, i) => (
                                                                    <div key={(i + 1) + 'inedu'} data-id={item.id} data-level="2" data-value={item.nombre} data-name="institucionProcedencia" className="search-result-item" onClick={this.onClickResultItem}>
                                                                        <small>{item.nombre}</small>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                        <div className="invalid-feedback"></div>
                                                    </div>

                                                    <div className="invalid-feedback"></div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="discapacidad" className="pb-2">¿Tiene algún tipo de discapacidad?
                                                    <span className="text-danger"> *</span><span className='info-tooltip'><img width="20px" alt='' src={InfoIcon} /> <div className="info"><img alt='' src={TooltipDiscapacidad} />
                                                    </div></span>
                                                </label>
                                                <div>
                                                    <label htmlFor="estadoCivil" className="pb-2">Si <span className="text-danger"></span></label>
                                                    <input className="form-check-input" style={{ marginLeft: 5 }} checked={selected_discapacidad.opt1} onChange={this.onChange} type="checkbox" id="noTieneDiscapacidad" name="discapacidad_option_1" />
                                                    <label htmlFor="estadoCivil" style={{ marginLeft: 15 }} className="pb-2">No <span className="text-danger"></span></label>
                                                    <input className="form-check-input" style={{ marginLeft: 5 }} checked={selected_discapacidad.opt2} onChange={this.onChange} type="checkbox" id="noTieneDiscapacidad" name="discapacidad_option_2" />
                                                </div>

                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="tipoDiscapacidad" className="pb-2">Tipo de discapacidad
                                                    {selected_discapacidad.opt1 && <span className="text-danger">*</span>}
                                                </label>
                                                <select className="form-control" id="tipoDiscapacidad" disabled={selected_discapacidad.opt2} name="tipoDiscapacidad" value={this.props.pro.tipoDiscapacidad || -1} onChange={this.onChange}>
                                                    <option disabled value={-1}>Selecciona una opción</option>
                                                    {
                                                        tipos_discapacidad && tipos_discapacidad.map((item, i) => (
                                                            <option key={(item.id) + 'tdisc'} value={item.id}>{item.value}</option>
                                                        ))
                                                    }
                                                </select>
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-4">
                                            <div className="form-group pb-2">
                                                <label htmlFor="celular" className="pb-2">Detalla el tipo de discapacidad
                                                    {selected_discapacidad.opt1 && <span className="text-danger">*</span>}
                                                </label>
                                                <input type="text" className="form-control" id="discapacidad" name="discapacidad"
                                                    disabled={selected_discapacidad.opt2}
                                                    value={this.props.pro.discapacidad}
                                                    placeholder="Detalla el tipo de discapacidad"
                                                    onChange={this.onChange}
                                                    aria-describedby="nameHelp"
                                                />
                                                <div className="invalid-feedback"></div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Save */}
                                    <div className="row pt-2 pb-2">
                                        <div className="col-sm-12 col-md-4">
                                            <small className="text-danger">*Obligatorio</small>
                                        </div>
                                        <div className="col-sm-12 col-md-4"></div>
                                        <div className="col-sm-12 col-md-4" style={{ textAlign: 'right' }}>
                                            <button className={(next_active) ? 'btn btn-primary btn-style-4' : (can_edit) ? 'btn btn-primary btn-style-4 disable' : 'btn btn-primary btn-style-4'}
                                                onClick={this.onClickNext}>Siguiente paso <i className="fa fa-arrow-right" aria-hidden="true"></i></button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div >
                <Modal size="md" show={show_info} onHide={this.hideInfo}>
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body> <h5 className="text-center"><strong>Política de Datos Personales</strong></h5></Modal.Body>
                    <Modal.Footer>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12">
                                    <p><small style={{ display: 'block', textAlign: 'justify' }}>
                                        <strong>Acorde a las Políticas de la Escuela de Postgrado de la UTP, los documentos oficiales que esta emita consignarán los nombres, prenombres y apellidos que figuren en el Documento Nacional de Identidad acorde al registro en RENIEC.</strong>
                                    </small>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GeneralDataPage);